import React from "react";

/**
 * Compact period selector. Use in ChartBox's rightNode.
 * props:
 *  - value: "day" | "week" | "month"
 *  - onChange: (next) => void
 *  - options?: array of { value, label }  // default: day/week/month
 */
export default function PeriodDropdown({ value, onChange, options }) {
  const opts = options || [
    { value: "day", label: "Daily" },
    { value: "week", label: "Weekly" },
    { value: "month", label: "Monthly" },
  ];
  return (
    <select
      className="form-select form-select-sm"
      style={{ width: 130 }}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      aria-label="Aggregation period"
    >
      {opts.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  );
}
